import Auth from '@/views/Auth'
import Configs from '@/views/Configs'
import Error from '@/views/Error'
import FileEditor from '@/views/FileEditor'
import Home from '@/views/Home'
import Members from '@/views/members/Members'
import MembersCreate from '@/views/members/MembersCreate'
import MembersEdit from '@/views/members/MembersEdit'
import OverrideFileEditor from '@/views/OverrideFileEditor'
import Approvals from '@/views/Approvals'
import Sso from '@/views/Sso'
import store from '@/store'
import EpgConfiguration from '@/views/EpgConfiguration'
import AssetManager from '@/views/AssetManager'
import TeamMashup from '@/views/TeamMashup'
import Banners from '@/views/Banners'
import CalendarConfiguration from "@/views/CalendarConfiguration"
import SponsorshipConfig from "@/views/SponsorshipConfig"
import WebView from "../views/WebView"
import Branding from "../views/Branding"
import AppNavigation from "../views/AppNavigation"
import Stats from "@/views/Stats"
import CDMenu from "@/views/CDMenu"
import UnsupportedBrowser from "@/views/UnsupportedBrowser"
import Messages from "@/views/Messages"
import Paywall from "@/views/Paywall"
import PaywallV1 from "@/views/PaywallV1"
import MobileUtilPages from "@/views/MobileUtilPages"
import StringOverride from "@/views/StringOverride"
import GumboWebsocketDriver from "@/views/GumboWebsocketDriver"


// Because the Okta widget used in the login component requires a browser, we have to lazily initialize it for unit tests to work.
const Login = () => import('@/views/Login')

export default [
  {
    path: '/',
    name: 'Root',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/implicit/callback',
    name: 'Auth',
    component: Auth,
  },
  {
    path: "/sso",
    name: 'SSO',
    component: Sso,
  },
  {
    path: "/unsupportedbrowser",
    name: "UnsupportedBrowser",
    component: UnsupportedBrowser,
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
  },
  {
    path: "/members",
    name: 'Members',
    component: Members,
    meta: {
      requiresAuth: true,
      requiresRoleFn: () => store.getters.canMembersView,
    },
  },
  {
    path: "/members/create",
    component: MembersCreate,
    meta: {
      requiresAuth: true,
      requiresRoleFn: () => store.getters.canMembersEdit,
    },
  },
  {
    path: "/members/edit/:login",
    name: 'MembersEdit',
    component: MembersEdit,
    meta: {
      requiresAuth: true,
      requiresRoleFn: () => store.getters.canMembersEdit,
    },
  },
  {
    path: '/configs',
    component: Configs,
    meta: {
      requiresAuth: true,
      feature: 'configs',
      requiresRoleFn: () => store.getters.canConfigsView,
    },
  },
  {
    path: '/files/edit/:id',
    component: FileEditor,
  },
  {
    path: '/overridefiles/edit/:id',
    component: OverrideFileEditor,
  },
  {
    path: '/approve',
    component: Approvals,
  },
  {
    path: '/calendarconfiguration',
    component: CalendarConfiguration,
    meta: {
      requiresAuth: true,
      feature: 'calendar-configuration',
      requiresRoleFn: () => store.getters.canScoreboardFlipView,
    },
  },
  {
    path: '/epgcontentconfig',
    component: EpgConfiguration,
    meta: {
      requiresAuth: true,
      feature: 'epg-content-config',
      requiresRoleFn: () => store.getters.canEpgContentConfigView,
    },
  },
  {
    path: '/sponsorshipconfig',
    component: SponsorshipConfig,
    meta: {
      requiresAuth: true,
      feature: 'sponsorship-config',
      requiresRoleFn: () => store.getters.canSponsorshipConfigView,
    },
  },
  {
    path: '/assets',
    component: AssetManager,
    meta: {
      requiresAuth: true,
      feature: 'asset-manager',
      requiresRoleFn: () => store.getters.canAssetManagerView,
    },
  },
  {
    path: '/team-mashup',
    component: TeamMashup,
    meta: {
      requiresAuth: true,
      feature: 'team-mashup',
      requiresRoleFn: () => store.getters.canTeamMashupView,
    },
  },
  {
    path: '/banners',
    component: Banners,
    meta: {
      requiresAuth: true,
      feature: 'banners',
      requiresRoleFn: () => store.getters.canBannersView,
    },
  },
  {
    path: '/webview',
    component: WebView,
    meta: {
      requiresAuth: true,
      feature: 'webview',
      requiresRoleFn: () => store.getters.canWebviewView,
    },
  },
  {
    path: '/branding',
    component: Branding,
    meta: {
      requiresAuth: true,
      feature: 'branding',
      requiresRoleFn: () => store.getters.canBrandingView,
    },
  },
  {
    path: '/app-navigation',
    component: AppNavigation,
    meta: {
      requiresAuth: true,
      feature: 'app-navigation',
      requiresRoleFn: () => store.getters.canAppNavigationView,
    },
  },
  {
    path: "/stats",
    component: Stats,
    meta: {
      requiresAuth: true,
      feature: "stats",
      requiresRoleFn: () => store.getters.canStatsView,
    },
  },
  {
    path: "/cdmenu",
    component: CDMenu,
    meta: {
      requiresAuth: true,
      feature: "cdmenu",
      requiresRoleFn: () => store.getters.canCDMenuView,
    },
  },
  {
    path: "/messages",
    component: Messages,
    meta: {
      requiresAuth: true,
      feature: "messages",
      requiresRoleFn: () => store.getters.canMessagesConfigView,
    },
  },
  {
    path: "/paywall",
    component: Paywall,
    meata: {
      requiresAuth: true,
      feature: "paywall",
      requiresRoleFn: () => store.getters.canPaywallView,
    },
  },
  {
    path: "/paywall/v1",
    component: PaywallV1,
    meta: {
      requiresAuth: true,
      feature: "paywall",
      requiresRoleFn: () => store.getters.canPaywallView,
    },
  },
  {
    path: "/mobile-util-pages",
    component: MobileUtilPages,
    meata: {
      requiresAuth: true,
      feature: "mobile-util-pages",
      requiresRoleFn: () => store.getters.canMobileUtilPagesView,
    },
  },
  {
    path: "/string-override",
    component: StringOverride,
    meata: {
      requiresAuth: true,
      feature: "string-override",
      requiresRoleFn: () => store.getters.canStringOverrideView,
    },
  },
  {
    path: "/gumbo-websocket-driver",
    component: GumboWebsocketDriver,
    meata: {
      requiresAuth: true,
      feature: "gumbo-websocket-driver",
      requiresRoleFn: () => store.getters.canGumboWebSocketDriverDrive,
    },
  },
]
